import { Box, StatusIndicator, styled } from '@driftt/dds'

export const CubeFilterButtonIconContainer = styled(Box, {
  position: 'relative',
})

export const CubeFilterButtonIndicator = styled(StatusIndicator, {
  position: 'absolute',
  top: '-2px',
  right: '-2px',
})
